import * as vp from 'vopay';
import * as Yup from 'yup';
import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import useBuildUpdateFlinksRows from './buildUpdateFlinksRows.helper';
import { useTranslation } from 'react-i18next';

const { Box, Button, Title, Table, TextField } = vp;

type UpdateFlinksProps = {
  onSubmit: (params: vp.SetFlinksCredentialsRequest) => void;
  defaultValues: vp.SetFlinksCredentialsRequest;
};
type FC = FunctionComponent<UpdateFlinksProps>;

const UpdateFlinks: FC = (props: UpdateFlinksProps) => {
  const { onSubmit, defaultValues } = props;
  const updateFlinksRows = useBuildUpdateFlinksRows();
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.Flinks.Update.Form' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  return (
    <Formik
      enableReinitialize
      initialValues={defaultValues}
      onSubmit={onSubmit}
      validationSchema={createdValidationSchema()}
      validateOnChange
      validateOnBlur
    >
      {({ values, touched, errors, handleChange, handleBlur, handleSubmit }) => {
        const updateFlinksTable: vp.TableProps = {
          name: 'update-flinks-fields',
          variant: 'pair',
          columns: {
            Field: { header: 'Labels' },
            Input: { header: 'Fields' },
          },
          rows: updateFlinksRows.map(({ label, id, preset }) => ({
            Field: label,
            Input: (
              <TextField
                preset={preset}
                key={id}
                name={id}
                variant="standard"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values[id]}
                error={errors[id] && touched[id] ? errors[id] : null}
              />
            ),
          })),
        };
        return (
          <form onSubmit={handleSubmit}>
            <Box mb="md" jc="sb">
              <Title title={t('pageTitle')} />
            </Box>
            <Table {...updateFlinksTable} />
            <Box mt="md" jc="fe">
              <Button id="Flinks-review" type="submit" label={tGlobal('Buttons.review')} />
            </Box>
          </form>
        );
      }}
    </Formik>
  );
  function createdValidationSchema() {
    return Yup.object().shape({
      FlinksUrl: Yup.string()
        .label(t('flinksUrl'))
        .required()
        .matches(/^.*\S+.*/, t('whiteSpaceValidation')),
    });
  }
};

export default UpdateFlinks;
